import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Play, Mic, FilePenLine, MessageSquareMore } from 'lucide-react';

const MobileToolbar = ({ 
  onPlayClick, 
  onMicClick, 
  onEditClick, 
  onMessageClick,
  hasAudio
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 60,
        backgroundColor: 'background.paper',
        borderTopRightRadius: '10px',
        borderTopLeftRadius: '10px',
        boxShadow: '0px -3px 16px 0px rgba(0, 0, 0, 0.20)',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 11
      }}
    >
      {/* Play Button */}
      <IconButton 
        onClick={onPlayClick}
        disabled={!hasAudio}
        sx={{ 
          color: hasAudio ? 'text.primary' : 'text.disabled',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 1
        }}
      >
        <Play />
      </IconButton>

      {/* Microphone Button */}
      <IconButton 
        onClick={onMicClick}
        sx={{ 
          color: 'text.primary',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 1,
          strokeWidth: 3,
        }}
      >
        <Mic />
      </IconButton>

      {/* Edit Button */}
      <IconButton 
        onClick={onEditClick}
        sx={{ 
          color: 'text.primary',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 1
        }}
      >
        <FilePenLine />
      </IconButton>

      {/* Message Button */}
      <IconButton 
        onClick={onMessageClick}
        sx={{ 
          color: 'text.primary',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 1
        }}
      >
        <MessageSquareMore />
      </IconButton>
    </Box>
  );
};

export default MobileToolbar; 